import { useCallback, useMemo } from 'react';
import useCheckboxField from '../Checkbox/useCheckboxField';
import { ToggleButtonProps } from './ToggleButton.types';

const usePresenter = (props: ToggleButtonProps) => {
  const {
    value,
    checked,
    defaultChecked = false,
    onValueChange,
    disabled = false,
    required = false,
    invalid = false,
    children,
    className,
    appearance = 'Default',
    style = 'Primary',
    size = 'Medium',
    id,
    ...otherProps
  } = props;

  const { isChecked, onCheckboxChanged } = useCheckboxField({ checked, defaultChecked, value, onValueChange });

  return {
    otherProps,
    isChecked,
    handleChange: onCheckboxChanged,
    disabled,
    required,
    invalid,
    className,
    appearance,
    style,
    size,
    id,
  };
};

export default usePresenter;